import AuthProvider from './Auth.provider';

export default AuthProvider;
